export function mapTouched(data) {
  let exp = {}
  for (const d of data) {
    exp[`${d}Touched`] = false
  }
  return exp
}

export function mapRequired(fields) {
  let exp = {}
  for (const field of fields) {
    exp[`${field}Valid`] = function() {
      return this[field] !== '' && this[`${field}Touched`]
    }
    exp[`${field}Invalid`] = function() {
      return !this[field] && this[`${field}Touched`]
    }
  }

  return exp
}

export function mapEqual(fields) {
  let exp = {}
  for (const [k, v] of fields) {
    exp[`${k}EqualValid`] = function() {
      return this[k] === this[v] && this[`${k}Touched`]
    }
    exp[`${k}EqualInvalid`] = function() {
      return (this[k] !== this[v] || !this[k]) && this[`${k}Touched`]
    }
  }
  return exp
}

export function mapRequiredIf(fields, fn) {
  let exp = {}
  fields.forEach(field => {
    exp[`${field}IfValid`] = function() {
      return (
        this[`${field}Touched`] && !!this[field] && fn.bind(this)(this[field])
      )
    }
    exp[`${field}IfInvalid`] = function() {
      return (
        this[`${field}Touched`] && !!this[field] && !fn.bind(this)(this[field])
      )
    }
  })
  return exp
}

export function mapValidateRegex(fields, regex) {
  let exp = {}
  fields.forEach(field => {
    exp[`${field}RegexValid`] = function() {
      return this[`${field}Touched`] && !!this[field] && regex.test(this[field])
    }
    exp[`${field}RegexInvalid`] = function() {
      return !(
        this[`${field}Touched`] &&
        !!this[field] &&
        regex.test(this[field])
      )
    }
  })
}

export function validationHelpers() {
  return {
    markAllTouched: function() {
      Object.keys(this.$data).forEach(k => {
        if (/Touched$/.test(k)) this[k] = true
      })
    },
    markAllNotTouched: function() {
      Object.keys(this.$data).forEach(k => {
        if (/Touched$/.test(k)) this[k] = false
      })
    },
  }
}

export function passwordValidators(password, username, firstName, lastName) {
  return {
    passwordLengthInvalid: function() {
      return this[password].length < 8 || this[password].length > 20
    },
    passwordUserNameInvalid: function() {
      return (new RegExp(this[username].toLowerCase())).test(this[password].toLowerCase())
    },
    passwordFirstLastNameInvalid: function() {
      return (new RegExp(this[firstName].toLowerCase())).test(this[password].toLowerCase()) || 
              (new RegExp(this[lastName].toLowerCase())).test(this[password].toLowerCase())
    },
    passwordLowercaseInvalid: function() {
      return !/[a-z]/.test(this[password])
    },
    passwordUppercaseInvalid: function() {
      return !/[A-Z]/.test(this[password])
    },
    passwordNumeralInvalid: function() {
      return !/[0-9]/.test(this[password])
    },
    passwordSpecialInvalid: function() {
      return /[+=]/.test(this[password]) || !/[^A-Za-z0-9]/.test(this[password])
    },
    passwordTwoConsecutiveCharactersInvalid: function() {
      return /(.)\1{2,}/.test(this[password])
    },
    passwordNineConsecutiveNumbersInvalid: function() {
      return /\d{9}/.test(this[password])
    },
    passwordWhitespaceInvalid: function() {
      return /\s/.test(this[password])
    },
    passwordAnyInvalid: function() {
      return (
        (this.passwordInvalid ||
          this.passwordLengthInvalid ||
          this.passwordUserNameInvalid ||
          this.passwordFirstLastNameInvalid ||
          this.passwordLowercaseInvalid ||
          this.passwordUppercaseInvalid ||
          this.passwordNumeralInvalid ||
          this.passwordSpecialInvalid ||
          this.passwordTwoConsecutiveCharactersInvalid ||
          this.passwordNineConsecutiveNumbersInvalid ||
          this.passwordWhitespaceInvalid) &&
        this[`${password}Touched`]
      )
    },
  }
}

export function phoneNumberValidators(phone, computedValueName = 'phoneFormatInvalid') {
  return {
    [computedValueName]: function(){
      return (
        !!this[phone] &&
        this[`${phone}Touched`] &&
        !this[phone].match(
          /^\d{10}$|^\d{3}[.-]\d{3}[.-]\d{4}$|^\(\d{3}\)\s?\d{3}[.-]?\d{4}$/,
        )
      )
    },
  }
}